import { Typography, TypographyProps } from '@mui/material'
import { FC } from 'react'

const Title: FC<TypographyProps> = ({ children, ...props }) => (
  <Typography variant="h1" {...props}>
    {children}
  </Typography>
)

export { Title }
